import axios from '../../../../../utils/axios';

interface DesktopPicture {
    id: string;
    configType: string;
    pictureUrl: string;
    used: 1 | 0;
}

interface DesktopPictureConfig {
    logo: DesktopPicture[];
    background: DesktopPicture[];
}

export async function getDesktopConfig() {
    const data = await axios.request<DesktopPictureConfig>({
        url: '/api/ops/config/picture/desktop'
    });
    const logo = data.logo?.[0];
    const backgrounds = data.background || [];
    return {
        logoId: logo?.id,
        logo: logo?.pictureUrl,
        backgrounds: backgrounds
    };
}

export async function removeDesktopBackground(id: string) {
    await axios.request({
        method: 'delete',
        url: `/api/ops/config/picture/delete/${id}`
    });
}

export async function editDesktopBackground(id: string) {
    await axios.request({
        method: 'put',
        url: `/api/ops/config/picture/update`,
        data: { id: id, used: 1 }
    });
}
